<template>
  <div>
    <DashboardHeader title="Manage Staff">
      <v-layout row wrap>
        <v-flex sm3 xs12>
          <v-card class="mx-1 mt-4">
            <v-toolbar color class="mb-1">
              <v-toolbar-title :style="{ color: getOutlineColor }" class="ml-1"
                >Add Staff</v-toolbar-title
              >
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-virtual-scroll :items="[1]" height="600" item-height="600">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-list-item three-line class="mt-2">
                        <v-card
                          v-if="isAdmin"
                          shaped
                          elevation="12"
                          max-width="344"
                          outlined
                        >
                          <CreateStaff
                            @staff-created="refreshStaffList"
                          ></CreateStaff>
                        </v-card>
                      </v-list-item>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-flex>
        <v-flex sm3 xs12>
          <v-card class="mx-1 mt-4">
            <v-toolbar color class="mb-1">
              <v-toolbar-title :style="{ color: getOutlineColor }"
                >Staff</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-switch
                v-model="employeesSwitch"
                class="mt-6 mr-2"
                label="All"
                @change="handleEmployeesSwitch()"
              ></v-switch>
              <v-btn
                class="ml-2"
                x-small
                rounded
                dark
                @click="openApplySalaryDialog()"
                color="#2E7D32"
                ><v-icon x-small>mdi-plus</v-icon>Salary</v-btn
              >

              <v-icon @click="deleteSelectedEmployees()" color="red"
                >mdi-delete</v-icon
              >
            </v-toolbar>

            <v-virtual-scroll :items="employees" height="600" item-height="130">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                      <v-list-item-content v-if="showEmployeesToBeSelected">
                       <v-list-item-title v-text="props.item.name"></v-list-item-title>
                       <v-list-item-title v-if="props.item.salary">
                        {{'Basic: '+getCurrency+props.item.salary.amount }}
                       </v-list-item-title>
                       <v-list-item-title v-if="props.item.total_rate">
                        {{'Total Rates: '+getCurrency+props.item.total_rate }}
                       </v-list-item-title>
                       <v-list-item-title v-if="props.item.total_earnings">
                        {{'Other Earnings: '+getCurrency+props.item.total_earnings }}
                       </v-list-item-title>
                       <v-list-item-title v-if="props.item.total_deductions">
                        {{'Total Deductions: '+getCurrency+props.item.total_deductions}}
                       </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                        <v-checkbox
                              class="shrink"
                              :value="props.item.id_number"
                              v-model="selectedStaff"
                            ></v-checkbox>

                            <v-btn
                              @click="getEmployeeProfile(props.item)"
                              fab
                              :style="getThemeStyle"
                              x-small
                              dark
                              ><v-icon>mdi-account</v-icon>
                              </v-btn
                            >
                        </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-flex>
        <v-flex sm6 xs12>
          <v-card class="ml-1 mt-4">
            <v-toolbar color class="mb-1">
              <v-toolbar-title :style="{ color: getOutlineColor }">{{
                selectedEmployee
                  ? selectedEmployee.name
                  : "Staff Profile [None Selected]"
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-virtual-scroll :items="[1]" height="600" item-height="600">
              <template v-slot:default="props" v-if="selectedEmployee">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-card
                        v-if="selectedEmployeeData.length > 0"
                        class="mt-4"
                      >
                        <v-container>
                          <v-row>
                            <v-col
                              cols="4"
                              v-for="(dataArr, i) in selectedEmployeeData"
                              :key="i + Math.random() + Math.random()"
                            >
                              <v-card shaped class="mt-4">
                                <v-card-text
                                  :style="{
                                    'backgroung-color': getThemeColor,
                                  }"
                                  >{{
                                    dataArr[0].toUpperCase().replace("_", " ")
                                  }}</v-card-text
                                >
                                <div>
                                  <ForeignKeyField
                                    class="mx-2 mt-n4"
                                    v-if="
                                      dataArr[0].includes('_id') &&
                                      dataArr[0].endsWith('_id') &&
                                      isManager
                                    "
                                    table="salaries"
                                    :foreignFieldValue="dataArr[1]"
                                    @field-selected="
                                      (catArr) => {
                                        dataArr[1] = catArr[0];
                                        updateField(
                                          selectedEmployee.id,
                                          dataArr[0],
                                          catArr[0]
                                        );
                                      }
                                    "
                                  ></ForeignKeyField>
                                  <v-text-field
                                    dense
                                    v-else-if="isAdmin"
                                    class="mx-2"
                                    :value="dataArr[1]"
                                    @change="
                                      updateField(
                                        selectedEmployee.id,
                                        dataArr[0]
                                      )
                                    "
                                  ></v-text-field>
                                  <span
                                    v-else
                                    class="mx-2"
                                    @change="
                                      updateField(
                                        selectedEmployee.id,
                                        dataArr[0]
                                      )
                                    "
                                    >{{ dataArr[1] }}</span
                                  >
                                </div>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-flex>
      </v-layout>

      <GlobalDialogSlot
        :dialog="dialog"
        :title="dialogTitle"
        @close-dialog="closeDialog"
      >
        <v-col class="mx-2" cols="10">
          <v-select
            max-width="344"
            :items="salaryItems"
            v-model="selectedSalaryItemCategory"
            label="Select Category"
            @change="getSelectedSalaryCategory()"
          ></v-select>
        </v-col>
        <div v-if="selectSalary">
          <SelectStaffSalary
            @salary-selected="getSelectedSalary"
          ></SelectStaffSalary>
          <v-card-actions>
            <v-btn
              :color="getThemeColor"
              dark
              class="ml-4 mt-4 mb-4"
              rounded
              @click="applySalaryNow()"
              ><v-icon>mdi-plus</v-icon>Apply Selected Salary</v-btn
            >
          </v-card-actions>
        </div>
        <div v-else-if="selectHourly">
          <SelectStaffRate @rate-selected="getSelectedRate"></SelectStaffRate>

          <div>
            <v-text-field
              label="Staff Total Hours"
              v-model="hoursWorked"
              class="ml-6 mr-16 mt-6"
            >
            </v-text-field>
          </div>
        </div>
        <div v-else-if="selectEarning">
          <v-layout row wrap>
            <v-flex sm6 xs12 class="px-2">
              <v-text-field
                class="ml-6"
                label="Description"
                v-model="salaryItemName"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-text-field
                class="mr-8"
                label="Amount"
                v-model="salaryItemAmount"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div v-else-if="selectDeduction">
          <v-layout row wrap>
            <v-flex sm6 xs12 class="px-2">
              <v-text-field
                class="ml-6"
                label="Description"
                v-model="salaryItemName"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-text-field
                class="mr-8"
                label="Amount"
                v-model="salaryItemAmount"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="selectedSalaryItemCategory && !selectSalary">
          <v-select
            max-width="344"
            class="mx-4"
            :items="months"
            v-model="payrollMonth"
            label="Select Payroll Month"
          ></v-select>
        </div>
        <div
          v-if="selectedSalaryItemCategory && !selectSalary && !selectHourly"
        >
          <v-card-actions
            v-if="salaryItemName && salaryItemAmount && payrollMonth"
          >
            <v-btn
              :color="selectDeduction ? 'red' : getThemeColor"
              dark
              class="ml-4 mt-4 mb-4"
              rounded
              @click="captureEarningAndDeductionNow()"
              ><v-icon>mdi-plus</v-icon>{{ dialogTitle }} Now</v-btn
            >
          </v-card-actions>
        </div>
        <v-card-actions v-else-if="selectedSalaryItemCategory && selectHourly">
          <v-btn
            v-if="hoursWorked && selectedRate && payrollMonth"
            :color="getThemeColor"
            dark
            class="ml-4 mt-4 mb-4"
            rounded
            @click="captureRateNow()"
            ><v-icon>mdi-plus</v-icon>Capture Rate</v-btn
          >
        </v-card-actions>
      </GlobalDialogSlot>

      <GlobalConfirmDeleteDialog
        @delete-confirmed="deleteSelectedEmployeesNow"
        item="Selected Staff"
      ></GlobalConfirmDeleteDialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import CreateStaff from "@/components/StaffAndHR/CreateStaff.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import SelectStaffSalary from "@/components/StaffAndHR/SelectStaffSalary.vue";
import SelectStaffRate from "@/components/StaffAndHR/SelectStaffRate.vue";
import ForeignKeyField from "@/components/myLibrary/ForeignKeyField.vue";

export default {
  components: {
    DashboardHeader,
    CreateStaff,
    GlobalConfirmDeleteDialog,
    GlobalDialogSlot,
    SelectStaffSalary,
    SelectStaffRate,
    ForeignKeyField,
  },
  computed: {
    hasCredits() {
      return this.messageCredit >= this.selectedStudents.length;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getBulkSMSTokenId() {
      return this.$store.getters.getBulkSMSTokenId;
    },
    getBulkSMSTokenSecret() {
      return this.$store.getters.getBulkSMSTokenSecret;
    },
    getBulkSMSBasicAuth() {
      return this.$store.getters.getBulkSMSBasicAuth;
    },
  },
  watch: {
    selectedEmployee(newVal) {
      this.getEmployeeProfile(newVal);
    },
  },
  mounted() {
    this.getAllEmployees();
  },
  data: () => ({
    hoursWorked: null,
    selectSalary: false,
    selectHourly: false,
    selectEarning: false,
    selectDeduction: false,
    payrollMonth: null,
    otherSalaryItemCategory: null,
    salaryItemName: null,
    salaryItemAmount: null,
    dialogTitle: 'Select Category',
    months: [
      { text: "January", value: 1 },
      { text: "February", value: 2 },
      { text: "March", value: 3 },
      { text: "April", value: 4 },
      { text: "May", value: 5 },
      { text: "June", value: 6 },
      { text: "July", value: 7 },
      { text: "August", value: 8 },
      { text: "September", value: 9 },
      { text: "October", value: 10 },
      { text: "November", value: 11 },
      { text: "December", value: 12 },
    ],
    staff: [],
    selectedSalaryID: null,
    showEmployeesToBeSelected: true,
    employeesSwitch: null,
    selectedEmployees: [],
    selectedStaff: [],
    selectedRate: null,
    bulkSMSBody: null,
    messageCredit: null,
    selectedDate: new Date().toISOString().substr(0, 10),
    employees: [],
    datePicker: new Date().toISOString().substr(0, 10),
    selectedEmployeeData: [],
    selectedEmployee: null,
    dialog: false,
    applySalaryDialog: false,
    addEarnings: false,
    categories: [],
    earningsDescription: "Bonus",
    earningsAmount: 0,
    deductionsDescription: "Loan",
    deductionsAmount: 0,
    bulkSMS: false,
    bulkDelete: false,
    deductions: false,
    edAmount: null,
    blockReport: false,
    selectedRoleID: null,
    blockReportReason: "Contact Admin for Details",
    snackbarColor: "",
    snackbarModel: false,
    lname: null,
    fname: null,
    grade: null,
    students: [],
    nameRules: [(v) => !!v || "Field is required"],
    showActionButtons: false,
    search: null,
    allSelected: [],
    salaryItems: [
      { text: "Salary", value: 1 },
      { text: "Hourly Rate", value: 2 },
      { text: "Other Earnings", value: 3 },
      { text: "Deduction", value: 4 },
    ],
    selectedSalaryItemCategory: null,
    employeesSelectionHeaders: [
      { value: "selection" },
      {
        text: "Staff",
        align: "start",
        value: "name",
      },
    ],
    headers: [
      { value: "selection" },
      { text: "Profile", value: "profile" },
      {
        text: "Staff ID",
        align: "start",
        value: "employee_id",
      },
      { text: "Name", value: "name" },
      { text: "ID #", value: "id_passport" },
      { text: "Cell #", value: "tel" },
      { text: "Bank", value: "bank" },
      { text: "Acc. #", value: "account" },
      { text: "City", value: "city" },
    ],
  }),
  methods: {
    getSelectedSalaryCategory() {
      switch (this.selectedSalaryItemCategory) {
        case 1:
          this.selectSalary = true;
          this.selectHourly = false;
          this.selectEarning = false;
          this.selectDeduction = false;
          this.dialogTitle = "Apply Monthly Salary";
          break;
        case 2:
          this.selectHourly = true;
          this.selectSalary = false;
          this.selectEarning = false;
          this.selectDeduction = false;
          this.dialogTitle = "Select Rate and Hours Worked";
          break;
        case 3:
          this.selectEarning = true;
          this.selectSalary = false;
          this.selectHourly = false;
          this.selectDeduction = false;
          this.dialogTitle = "Capture Earnings";
          break;
        case 4:
          this.selectDeduction = true;
          this.selectSalary = false;
          this.selectHourly = false;
          this.selectEarning = false;
          this.dialogTitle = "Capture Deductions";

          break;
      }
    },
    getAllEmployees() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-employees", this.getAccessToken)
        .then((employees) => {
          this.employees = employees;
          this.$store.commit("setLoader", false);
        });
    },
    refreshStaffList() {
      this.getAllEmployees();
    },
    getSelectedDate(selectedDate) {
      this.selectedDate = selectedDate;
    },
    selectAllStaff() {
      if (this.selectAll) {
        this.selectedStaff = [];
        this.staff.forEach((staf) => {
          this.selectedStaff.push(staf.id);
        });
      } else {
        this.selectedStaff = [];
      }
    },
    captureEarningAndDeductionNow() {
      this.$store.commit("setLoader", true);
      let itemType = "";
      if (this.selectedSalaryItemCategory == 3) {
        itemType = "earning";
      } else {
        itemType = "deduction";
      }
      axios
        .postDataWithToken(
          "/auth/capture-earning-and-deduction-now",
          {
            itemType,
            selectedStaffIDs: this.selectedStaff,
            name: this.salaryItemName,
            amount: this.salaryItemAmount,
            payrollMonth: this.payrollMonth,
          },
          this.getAccessToken
        )
        .then(() => {
          if (this.selectedEmployee) {
            this.getEmployeeProfile(this.selectedEmployee);
          } else {
            this.getAllEmployees();
          }
          this.closeDialog();
          this.snackbarText = this.selectSalary
            ? "Salary Successfully Applied!"
            : "Data Successfully Captured!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
        });
    },
    openAddEarningsDialog() {
      if (this.selectedStaff.length < 1) {
        alert("You Must Select At least One(1) Staff!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.addEarnings = true;
      }
    },
    openApplySalaryDialog() {
      if (this.selectedStaff.length < 1) {
        alert("You Must Select At least One(1) Staff!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.applySalaryDialog = true;
      }
    },
    openBulkSMSDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.$store.commit("setLoader", true);
        axios
          .getData("/auth/get-messages-credit", this.getAccessToken)
          .then((credit) => {
            this.messageCredit = credit;
            this.$store.commit("setLoader", false);
          });
        this.dialog = true;
        this.bulkSMS = true;
      }
    },
    handleEmployeesSwitch() {
      if (this.employeesSwitch) {
        this.selectedStaff = [];
        this.employees.forEach((staff) => {
          this.selectedStaff.push(staff.id_number);
        });
      } else {
        this.selectedStaff = [];
      }
    },
    updateField(id, column, sal = 0) {
      let value = null;

      if (column == "salary_id") {
        value = sal;
      } else {
        value = event.target.value;
      }

      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "staff", id, column, value },
          this.getAccessToken
        )
        
    },
    getSelectedSalary(salaryID) {
      this.selectedSalaryID = salaryID;
    },
    getSelectedRate(rate) {
      this.selectedRate = rate;
    },
    applySalaryNow() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/apply-salary-to-selected-staff",
          {
            staffIDNumbers: this.selectedStaff,
            salaryID: this.selectedSalaryID,
          },
          this.getAccessToken
        )
        .then(() => {
          if (this.selectedEmployee) {
            this.getEmployeeProfile(this.selectedEmployee);
          } else {
            this.getAllEmployees();
          }
          this.closeDialog();
          this.snackbarText = "Salary Successfully Applied!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
        });
    },
    captureRateNow() {
      this.$store.commit("setLoader", true);
      const selectedRate = this.selectedRate.split("-");
      const total = (
        Number(this.hoursWorked) * Number(selectedRate[1])
      ).toFixed(2);
      axios
        .postDataWithToken(
          "/auth/capture-rate-now",
          {
            selectedStaffIDs: this.selectedStaff,
            hoursWorked: this.hoursWorked,
            selectedRateID: selectedRate[0],
            total,
            payrollMonth: this.payrollMonth,
          },
          this.getAccessToken
        )
        .then(() => {
          if (this.selectedEmployee) {
            this.getEmployeeProfile(this.selectedEmployee);
          } else {
            this.getAllEmployees();
          }
          this.closeDialog();
          this.snackbarText = "Rate Successfully Captured!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
        });
    },
    sendBulkSMSNow() {
      const bulkSMSBody = this.bulkSMSBody;
      const students = this.selectedStudents;
      if (this.selectedStudents.length > 0 && bulkSMSBody != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/send-bulk-sms",
            { bulkSMSBody, students },
            this.getAccessToken
          )
          .then((messages) => {
            if (messages == "none-sent") {
              this.$store.commit("setLoader", false);
              this.snackbarText = "Zero Messages Sent!";
              this.snackbarColor = "error";
              this.snackbarModel = true;
              this.closeDialog();
              return true;
            }
            if (messages.length && messages.length > 0) {
              axios
                .postDataWithToken(
                  "/auth/update-messages-table-with-sent-messages",
                  { messages, origin: "manage-students" },
                  this.getAccessToken
                )
                .then((response) => {
                  if (response == "success") {
                    this.$store.commit("setLoader", false);
                    this.snackbarText = "Messages Successfully Sent!";
                    this.snackbarColor = "success";
                    this.snackbarModel = true;
                    this.closeDialog();
                  }
                });
            } else {
              this.$store.commit("setLoader", false);
              this.snackbarText = messages.detail;
              this.snackbarColor = "red";
              this.snackbarModel = true;
              this.closeDialog();
            }
          });
      } else {
        alert("Message Body Field is Required!");
        event.preventDefault();
      }
    },
    getEmployeeProfile(selectedEmployee) {
      this.getAllEmployees();
      this.selectedEmployee = selectedEmployee;

      if (this.selectedEmployee != null) {
        this.selectedEmployeeData = [];
        const selectedEmployeeData = Object.entries(this.selectedEmployee);
        selectedEmployeeData.forEach((dataArr) => {
          if (
            dataArr[0] != "id" &&
            dataArr[0] != "emis" &&
            !dataArr[0].includes("sub_") &&
            !dataArr[0].includes("_at")
          ) {
            this.selectedEmployeeData.push(dataArr);
          }
        });
      }
    },
    deleteSelectedEmployees() {
      if (this.selectedStaff.length < 1) {
        alert("Select Aleast 1 Staff");
        event.preventDefault();
      } else {
        this.$store.commit("setGlobalConfirmDelete", true);
      }
    },
    deleteSelectedEmployeesNow(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/delete-selected-employees",
            { selectedEmployees: this.selectedStaff },
            this.getAccessToken
          )
          .then((staff) => {
            this.employees = staff;
            this.$store.commit("setLoader", false);
          });
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
      }
    },
    closeDialog() {
      this.dialog = false;
      this.applySalaryDialog = false;
      this.selectedStaff = [];
      this.selectSalary = false;
      this.selectHourly = false;
      this.selectEarning = false;
      this.selectDeduction = false;
      this.payrollMonth = null;
      this.salaryItemName = null;
      this.salaryItemAmount = null;
      this.selectedSalaryItemCategory = null;
      this.hoursWorked = null;
      this.selectedRate = null;
      this.employeesSwitch = false;
      this.dialogTitle = "Select Category"
      this.handleEmployeesSwitch();
    },
  },
};
</script>

<style></style>
